export const S3_BUCKET =
  false && process.env.NODE_ENV === "development"
    ? "cyberflow-dubuddy"
    : "cyberflow-dubuddy";
export const AWS_REGION = "ap-south-1";
export const IdentityPoolId =
  false && process.env.NODE_ENV === "development"
    ? "ap-south-1:050957c3-98f9-4d75-a32b-cb7053f6c7a1"
    : "ap-south-1:ab714953-0dd9-4fc8-a2f5-4b9bb9cb8990";

const { Configuration, OpenAIApi } = require("openai");
const configuration = new Configuration({
  //paid
  apiKey: "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",
  //free
  // apiKey: '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',
});
export const openai = new OpenAIApi(configuration);
